import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";

class Star extends PureComponent {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    d="M24,9.4c-0.1-0.3-0.4-0.5-0.7-0.5l-8-0.2l-2.6-7.2C12.6,1.2,12.3,1,12,1
                    c-0.3,0-0.6,0.2-0.7,0.5L8.7,8.7l-8,0.2C0.4,8.9,0.1,9.1,0,9.4c-0.1,0.3,0,0.6,0.3,0.8l6.4,4.6l-2.3,7.3c-0.1,0.3,0,0.6,0.3,0.8
                    c0.2,0.2,0.6,0.2,0.8,0l6.6-4.4l6.6,4.4C18.7,23,18.8,23,19,23c0.1,0,0.3,0,0.4-0.1c0.2-0.2,0.4-0.5,0.3-0.8l-2.3-7.3l6.4-4.6
                    C24,9.9,24.1,9.6,24,9.4"
                />
            </SvgIcon>
        );
    }
}

export default Star;
